import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/Overview/OverviewView.vue'),
    },
    {
      path: '/accounts',
      children: [
        {
          path: '',
          name: 'accounts',
          component: () => import('../views/Accounts/AccountsView.vue'),
        },
        {
          path: 'create',
          name: 'account-create',
          component: () => import('../views/Accounts/CreateConnectedAccountView.vue'),
        },
        {
          path: ':id/setup',
          name: 'account-setup',
          component: () => import('../views/Accounts/AccountSetupView.vue'),
        },
        {
          path: ':id/direct-payment',
          name: 'account-direct-payment',
          component: () => import('../views/Accounts/DirectPaymentOnboardingView.vue'),
        },
      ],
    },
    {
      path: '/payments',
      children: [
        {
          path: '',
          name: 'payments',
          component: () => import('../views/Payments/PaymentsView.vue'),
        },
        {
          path: ':id/refund',
          name: 'payments-refund',
          component: () => import('../views/Payments/PaymentRefundView/PaymentRefundView.vue'),
        },
      ],
    },
    {
      path: '/invoices',
      children: [
        {
          path: '',
          name: 'invoices',
          component: () => import('../views/Invoices/InvoicesView.vue'),
        },
        {
          path: ':id/refund',
          name: 'invoices-refund',
          component: () => import('../views/Invoices/InvoiceRefundView/InvoiceRefundView.vue'),
        },
      ],
    },
    {
      path: '/payouts',
      children: [
        {
          path: '',
          name: 'payouts',
          component: () => import('../views/Payouts/PayoutsView.vue'),
        },
        {
          path: ':id/payment-voucher',
          name: 'payouts-payment-voucher',
          component: () => import('pejer/src/views/Payouts/PaymentVoucher/PaymentVoucherView.vue'),
        },
      ],
    },
    {
      path: '/payouts',
      children: [
        {
          path: '',
          name: 'payouts',
          component: () => import('../views/Payouts/PayoutsView.vue'),
        },
        {
          path: ':id/payment-voucher',
          name: 'payouts-payment-voucher',
          component: () => import('pejer/src/views/Payouts/PaymentVoucher/PaymentVoucherView.vue'),
        },
      ],
    },
    {
      path: '/refunds/requests',
      children: [
        {
          path: '',
          name: 'refund-requests',
          component: () => import('../views/RefundRequests/RefundRequestsView.vue'),
        },
      ],
    },
    {
      path: '/external-account/onboarding',
      name: 'external-account-onboarding',
      component: () => import('../views/ExternalAccount/Onboarding.vue'),
    },
  ],
})

export default router
